import { MoreActionsButton } from 'owa-locstrings/lib/strings/moreactionsbutton.locstring.json';
import loc from 'owa-localize';
import { handleComponentOnBlur, handleComponentOnFocus } from '../utils/handleAttachmentViewFocus';
import { observer } from 'mobx-react';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { KeyCodes } from 'office-ui-fabric-react/lib/Utilities';
import {
    ActionType,
    AttachmentFullViewState,
    setAttachmentShouldShowContextMenu,
} from 'owa-attachment-full-data';
import { ControlIcons } from 'owa-control-icons';

import { AttachmentPreviewMode } from 'owa-sxs-store';
import { trace } from 'owa-trace';
import * as React from 'react';

export interface AttachmentContextMenuButtonProps {
    attachmentViewState: AttachmentFullViewState;
    isForImageView: boolean;
    previewState: AttachmentPreviewMode;
}

const classNames = require('classnames');
const styles = require('./AttachmentContextMenuButton.scss');

// This component is responsible for showing the attachment context menu button.
@observer
export default class AttachmentContextMenuButton extends React.Component<
    AttachmentContextMenuButtonProps,
    any
> {
    render() {
        const shouldHideContextMenuButton = this.getShouldHideContextMenuButton();
        if (!shouldHideContextMenuButton) {
            let classNameString: string;
            const attachmentStyle = this.getAttachmentStyle(this.props.previewState);
            if (this.props.isForImageView) {
                classNameString = classNames([
                    styles.contextMenuButton,
                    styles.contextMenuButtonForImageView,
                ]);
            } else if (this.props.attachmentViewState.isReadOnly) {
                classNameString = classNames([styles.contextMenuButton, attachmentStyle]);
            } else {
                classNameString = classNames([
                    styles.contextMenuButton,
                    attachmentStyle,
                    styles.contextMenuButtonForDocViewInCompose,
                ]);
            }
            return (
                <IconButton
                    onFocus={this.handleOnFocus}
                    onBlur={this.handleOnBlur}
                    onKeyDown={this.keyDown}
                    ariaLabel={loc(MoreActionsButton)}
                    aria-haspopup="true"
                    aria-expanded={this.props.attachmentViewState.shouldShowContextMenu}
                    title={loc(MoreActionsButton)}
                    onClick={this.onClickContextMenuButton}
                    className={classNameString}
                    iconProps={{
                        iconName: ControlIcons.ChevronDownMed,
                        styles: {
                            root: styles.icon,
                        },
                    }}
                />
            );
        } else {
            return null;
        }
    }

    private keyDown = (event: React.KeyboardEvent<unknown>) => {
        if (event.keyCode === KeyCodes.enter || event.keyCode === KeyCodes.space) {
            trace.info('AttachmentContextMenuButton.keyDown enter|space');
            event.stopPropagation();
            setAttachmentShouldShowContextMenu(this.props.attachmentViewState, true);
        }
    };

    private handleOnFocus = () => {
        handleComponentOnFocus(this.props.attachmentViewState, this.props.isForImageView);
    };

    private handleOnBlur = () => {
        handleComponentOnBlur(this.props.attachmentViewState, this.props.isForImageView);
    };

    private onClickContextMenuButton = (ev: any) => {
        trace.info('AttachmentContextMenuButton.onclick');
        ev.stopPropagation();
        setAttachmentShouldShowContextMenu(this.props.attachmentViewState, true);
    };

    private getShouldHideContextMenuButton(): boolean {
        // When there is a pending action processing the attachment, we should hide context menu button.
        const attachmentViewState = this.props.attachmentViewState;
        return (
            attachmentViewState.ongoingAction !== ActionType.None ||
            !this.props.attachmentViewState.strategy.showActionsMenu
        );
    }

    private getAttachmentStyle(previewState: AttachmentPreviewMode): string {
        switch (previewState) {
            case AttachmentPreviewMode.Edit:
                return styles.edit;
            case AttachmentPreviewMode.NotSelectedAndSaving:
                return styles.notSelectedAndSaving;
            case AttachmentPreviewMode.OtherSaving:
                return styles.attachmentView;
            case AttachmentPreviewMode.Selected:
                return styles.selected;
            case AttachmentPreviewMode.SelectedAndPending:
                return styles.selectedAndPending;
            case AttachmentPreviewMode.SelectedAndSaving:
                return styles.selectedAndSaving;
            default:
                return styles.none;
        }
    }
}
